import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { AppState } from 'app/types';
import { Loggable } from 'app/utils/logging/loggable';
import Paging from 'rest/Paging';
import SocialController from 'rest/SocialController';

import { ScootaversePageService } from '../services/scootaverse-page.service';

import { scootaversePageActions, scootaversePageSelectors } from '.';

@Injectable()
export class ScootaversePageEffects extends Loggable {
  public constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private scootaversePageService: ScootaversePageService,
  ) {
    super();
    this.setDisplayName('ScootaversePageEffects');
  }

  public fetchScootaverses$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(scootaversePageActions.FETCH_SCOOTAVERSES_REQ),
      mergeMap(({ page, size }) =>
        from(new SocialController().getMySocialRoomSets(new Paging(page, size))).pipe(
          map((roomSets) => scootaversePageActions.FETCH_SCOOTAVERSES_RSP({ roomSets })),
          tap({ error: (error: unknown) => this.error('fetchRooms$ error', error) }),
          catchError((error: unknown) => {
            // causing infinite loop if not logged in
            // this.scootaversePageService.fetchScootaverses();
            return of(scootaversePageActions.FETCH_SCOOTAVERSES_ERR({ error }));
          }),
        ),
      ),
    );
  });

  public refetch$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(),
      concatLatestFrom((_action) => this.store.select(scootaversePageSelectors.getScootaverses)),
      switchMap(([_, { size }]) => [scootaversePageActions.FETCH_SCOOTAVERSES_REQ({ page: 0, size })]),
    );
  });
}
